import React, { forwardRef, useCallback, useState, useEffect } from "react";
import MaskedInput from "react-text-mask";
import { utilities } from "@/_helpers";
import Cookies from "universal-cookie";
import LifeSaferLogo from "@/_images/logos/LogoLimited.png";
import LifeSaferiaLogo from "@/_images/logos/lifesaferiaLogo.png";

export function phoneNumberFormat(phoneNumber) {
  const countryCode = sessionStorage.getItem("LSCountryCode");
  if (phoneNumber === null || phoneNumber === undefined) {
    return "";
  }
  const cleanNumber = phoneNumber.replace(/\D/g, "");

  if (countryCode === "AU") {
    return cleanNumber.replace(
      /^(\d{1})(\d{1})(\d{2})(\d{3})(\d{3})$/,
      "$1$2$3-$4-$5",
    );
  } else if (countryCode === "EU") {
    return cleanNumber.replace(/^(\d{13})$/, "$1");
  } else {
    return cleanNumber.replace(/^(\d{3})(\d{3})(\d{4})$/, "($1) $2-$3");
  }
}

export function phoneNumberVerifyMask(phoneNumber) {
  const countryCode = sessionStorage.getItem("LSCountryCode");

  if (!phoneNumber) {
    return "";
  }

  const cleanNumber = phoneNumber.replace(/\D/g, "");
  const last4 = cleanNumber.slice(-4);

  if (countryCode === "AU") {
    return `(XXX) XXX-${last4}`;
  } else if (countryCode === "EU") {
    return `XXXXXXXXXXXX${last4}`;
  } else {
    return `(XXX) XXX-${last4}`;
  }
}

export function emailFormat(email) {
  if (!email || !email.includes("@")) return "";

  const [localPart, domain] = email.split("@");
  const masked = "X".repeat(localPart.length);

  return `${masked}@${domain}`;
}

export const PhoneMaskCustom = forwardRef(function TextMaskCustom(props, ref) {
  const countryCode = sessionStorage.getItem("LSCountryCode");
  const setRef = useCallback(
    (maskedInputRef) => {
      const value = maskedInputRef ? maskedInputRef.inputElement : null;

      if (typeof ref === "function") {
        ref(value);
      } else if (ref) {
        ref.current = value;
      }
    },
    [ref],
  );

  const handleKeyDown = (e) => {
    if (e.key === "Backspace") {
      const maskChars = new Set(["-", " ", "(", ")"]);
      const cursorPos = e.target.selectionStart;

      if (maskChars.has(e.target.value[cursorPos - 1])) {
        e.preventDefault();
        e.target.setSelectionRange(cursorPos - 1, cursorPos - 1);
      }
    }
  };

  if (countryCode === "AU") {
    return (
      <MaskedInput
        {...props}
        ref={setRef}
        mask={[
          /[0-1]/,
          /[0-5|7-8]/,
          /\d/,
          /\d/,
          "-",
          /\d/,
          /\d/,
          /\d/,
          "-",
          /\d/,
          /\d/,
          /\d/,
        ]}
        guide={false}
        placeholderChar={"\u2000"}
        onKeyDown={handleKeyDown}
      />
    );
  } else if (countryCode === "EU") {
    return (
      <MaskedInput
        {...props}
        ref={setRef}
        mask={[
          /\d/,
          /\d/,
          /\d/,
          /\d/,
          /\d/,
          /\d/,
          /\d/,
          /\d/,
          /\d/,
          /\d/,
          /\d/,
          /\d/,
          /\d/,
        ]}
        guide={false}
        placeholderChar={"\u2000"}
        onKeyDown={handleKeyDown}
      />
    );
  } else {
    return (
      <MaskedInput
        {...props}
        ref={setRef}
        mask={[
          "(",
          /[2-9]/,
          /[0-8]/,
          /[0-9]/,
          ")",
          " ",
          /[2-9]/,
          /[0-9]/,
          /\d/,
          "-",
          /\d/,
          /\d/,
          /\d/,
          /\d/,
        ]}
        guide={false}
        placeholderChar={"\u2000"}
        onKeyDown={handleKeyDown}
      />
    );
  }
});

//this code is needed in future

// export function useDeviceTypeWatcher() {
//   const cookies = new Cookies();

//   const safeParse = (key) => {
//     try {
//       const value = sessionStorage.getItem(key);
//       return value ? JSON.parse(value) : null;
//     } catch (err) {
//       console.warn(`Failed to parse sessionStorage[${key}]:`, err);
//       return null;
//     }
//   };

//   const getInitialDeviceType = () => {
//     const enrolleeUser = safeParse("enrolleeUser");
//     if (enrolleeUser?.clientTypeId) return enrolleeUser.clientTypeId;

//     try {
//       const lifeSaferUser = cookies.get("EnrollNow") || {};
//       return (
//         lifeSaferUser?.deviceType ||
//         lifeSaferUser?.DeviceType ||
//         lifeSaferUser?.clientTypeId ||
//         null
//       );
//     } catch (err) {
//       console.warn("Error reading EnrollNow cookie:", err);
//       return null;
//     }
//   };

//   const [deviceType, setDeviceType] = useState(getInitialDeviceType);

//   useEffect(() => {
//     const handleStorageChange = () => {
//       const enrolleeUser = safeParse("enrolleeUser");
//       const newType = enrolleeUser?.clientTypeId;
//       if (newType !== deviceType) {
//         setDeviceType(newType || getInitialDeviceType());
//       }
//     };

//     const originalSetItem = sessionStorage.setItem;
//     sessionStorage.setItem = function (key) {
//       try {
//         originalSetItem.apply(this, arguments);
//         if (key === "enrolleeUser") handleStorageChange();
//       } catch (err) {
//         console.warn("Error updating sessionStorage:", err);
//       }
//     };

//     window.addEventListener("storage", handleStorageChange);

//     return () => {
//       window.removeEventListener("storage", handleStorageChange);
//       sessionStorage.setItem = originalSetItem;
//     };
//   }, [deviceType]);

//   const normalized =
//     typeof utilities?.deviceInfo === "function"
//       ? utilities.deviceInfo(deviceType)
//       : { deviceType, deviceTypeId: deviceType };

//   let isISA = false;
//   let resolvedUrl = "";

//   try {
//     const lifeSaferUser = cookies.get("EnrollNow") || {};
//     const cookieUrl = (lifeSaferUser?.URL || "").toLowerCase();

//     const currentUrl =
//       typeof window !== "undefined" ? window.location.href.toLowerCase() : "";

//     isISA =
//       cookieUrl.includes("lifesaferisa") ||
//       currentUrl.includes("lifesaferisa") ||
//       normalized.deviceTypeId === 6;

//     if (isISA) {
//       resolvedUrl = "lifesaferisa.com";
//     } else if (cookieUrl.includes("speed")) {
//       resolvedUrl = "lifesaferisa.com";
//     } else {
//       resolvedUrl = "lifesafer.com";
//     }
//   } catch (err) {
//     console.warn("Error checking ISA URL from cookie:", err);
//   }

//   const phoneNumber = isISA
//     ? "(833) 396-8034"
//     : "(855) 221-0171";

//   return {
//     deviceType: normalized.deviceType || "Interlock",
//     deviceTypeId: normalized.deviceTypeId || 1,
//     isISA,
//     phoneNumber,
//     resolvedUrl: resolvedUrl,
//   };
// }

//Check Isa number and url and update in whole site
export function useDeviceTypeWatcher() {
  const cookies = new Cookies();

  const safeParse = (key) => {
    try {
      const value = sessionStorage.getItem(key);
      return value ? JSON.parse(value) : null;
    } catch (err) {
      console.warn(`Failed to parse sessionStorage[${key}]:`, err);
      return null;
    }
  };

  const getResolvedDeviceType = () => {
    const enrolleeUser = safeParse("enrolleeUser");
    if (enrolleeUser) {
      const sessionDeviceType =
        enrolleeUser?.clientTypeId ??
        enrolleeUser?.ClientTypeId ??
        enrolleeUser?.deviceType ??
        enrolleeUser?.DeviceType;

      if (sessionDeviceType) return sessionDeviceType;
    }

    try {
      const lifeSaferUser = cookies.get("EnrollNow") || {};
      return (
        lifeSaferUser?.deviceType ||
        lifeSaferUser?.DeviceType ||
        lifeSaferUser?.clientTypeId ||
        null
      );
    } catch (err) {
      console.warn("Error reading EnrollNow cookie:", err);
      return null;
    }
  };

  const [deviceType, setDeviceType] = useState(getResolvedDeviceType);

  useEffect(() => {
    const handleStorageChange = () => {
      setDeviceType((previousType) => {
        const nextType = getResolvedDeviceType();
        return previousType === nextType ? previousType : nextType;
      });
    };

    window.addEventListener("storage", handleStorageChange);
    window.addEventListener("focus", handleStorageChange);
    const intervalId = window.setInterval(handleStorageChange, 500);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("focus", handleStorageChange);
      window.clearInterval(intervalId);
    };
  }, []);

  const normalized =
    typeof utilities?.deviceInfo === "function"
      ? utilities.deviceInfo(deviceType)
      : { deviceType, deviceTypeId: deviceType };

  const computeISAData = () => {
    try {
      const lifeSaferUser = cookies.get("EnrollNow") || {};
      const cookieUrl = (lifeSaferUser?.URL || "").toLowerCase();
      const currentUrl =
        typeof window !== "undefined" ? window.location.href.toLowerCase() : "";

      const initialSpeedFlag =
        currentUrl.includes("speed") || cookieUrl.includes("speed");
        const isPartnerStoryUrl= currentUrl?.toLowerCase()?.includes("partner") || cookieUrl?.toLowerCase()?.includes("partner");

      const isISA =
        initialSpeedFlag ||
        cookieUrl.includes("lifesaferisa") ||
        currentUrl.includes("lifesaferisa") ||
        normalized.deviceTypeId === 6;

      const resolvedUrl = isISA ? "lifesaferisa.com" : "lifesafer.com";

      // const phoneNumber = isISA ? "(833) 396-8034" : (isPartnerStoryUrl ? "(800) 806-2478" : "(855) 221-0171");

      const phoneNumber=isPartnerStoryUrl ? "(800) 806-2478" : (isISA ?  "(833) 396-8034" : "(855) 221-0171");


      const siteLogo = isISA ? LifeSaferiaLogo : LifeSaferLogo;
      return { isISA, resolvedUrl, phoneNumber, siteLogo };
    } catch (err) {
      console.warn("Error computing ISA data:", err);
      return {
        isISA: false,
        resolvedUrl: "lifesafer.com",
        phoneNumber: "(855) 221-0171",
        siteLogo: LifeSaferLogo,
      };
    }
  };

  const { isISA, resolvedUrl, phoneNumber, siteLogo } = computeISAData();

  return {
    deviceType: normalized.deviceType || "Interlock",
    deviceTypeId: normalized.deviceTypeId || 1,
    isISA,
    phoneNumber,
    resolvedUrl,
    siteLogo,
  };
}
